module.exports = __webpack_public_path__ + "static/img/2.619031ac.png";